import { connect } from "react-redux";
import AppDrawer from "./AppDrawer";
import { DRAWER_STATE, closeDrawer } from "./actions/drawer";
import { forgetToken } from "./actions/prerequisites";

const mapStateToProps = (state, ownProps) => {
  const conductorAcc = Object.values(state.entities.accounts).find(
    o => o.name === "conductor"
  );
  const conductorId = conductorAcc && conductorAcc.id;
  const docked = state.ui.geometry.drawer === DRAWER_STATE.DOCKED;
  const open =
    state.ui.geometry.drawer !== DRAWER_STATE.HIDDEN && !state.ui.focused;
  const mode = state.prerequisites.config.MODE;

  return {
    mode,
    docked,
    open,
    externalLinks: [
      {
        url: state.prerequisites.config.STATIC_SITE,
        label: "Marketing site"
      },
      {
        url: state.prerequisites.config.DASHBOARD,
        label: "Conductor console"
      },
      { url: "", label: "Hubspot" },
      null,
      {
        url: state.prerequisites.config.ONBOARDING,
        label: "Log out"
      }
    ],
    conductorAccountUrl: `/accounts/${conductorId}`
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onCloseDrawer: () => {
      dispatch(closeDrawer());
    },
    forgetToken: () => {
      dispatch(forgetToken());
    }
  };
};

const AppDrawerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppDrawer);

export default AppDrawerContainer;



// WEBPACK FOOTER //
// ./src/AppDrawerContainer.js